import { defaultSchema } from 'rehype-sanitize';

// Custom sanitize schema that allows entity mention spans
// Uses data-entity attribute on <span> instead of custom <entity> tag
// to ensure inline parsing in markdown lists.
export const sanitizeSchema = {
  ...defaultSchema,
  attributes: {
    ...(defaultSchema.attributes || {}),
    span: [
      ...(defaultSchema.attributes?.['span'] || []),
      'dataEntity',
      // Meeting-slot chips (<span data-meeting-slot="true" id="UUID">) are
      // emitted by preprocessEntityTags for IdCodec meeting_slot references.
      // Without allowing this attribute, rehype-sanitize strips it and the
      // reasoning-chat renderer can never turn the span into a resolved-time
      // badge — matching the entitySanitizeSchema span allowlist.
      'dataMeetingSlot',
      'type',
      'id',
    ],
  },
  protocols: {
    ...(defaultSchema.protocols || {}),
    href: [...(defaultSchema.protocols?.href || []), 'ahoy'],
  },
  // Keep the default "user-content-" prefix for DOM clobbering protection.
  // We strip this prefix in the entity component below before passing to EntityBadgeById.
};
